//reviewAllowed
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ENewReviewFormReviewAllowed {
  Set = 'NEW_REVIEW/FORM/SET_REVIEW_ALLOWED',
}

export type TNewReviewReviewAllowed = ITypedReduxAction<ENewReviewFormReviewAllowed.Set, boolean>;

export type TNewReviewFormReviewAllowedActions = TNewReviewReviewAllowed;
